import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const RequireSuperadmin: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { user, isSuperadmin, loading } = useAuth();
  if (loading) return <div style={{ padding: 24 }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isSuperadmin) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Access Denied</h2>
        <p>Your account does not have super admin permissions.</p>
      </div>
    );
  }
  return children;
};

export default RequireSuperadmin;

